import { render, staticRenderFns } from "./ApprovalSuccessPage.vue?vue&type=template&id=0239e2eb&scoped=true"
import script from "./ApprovalSuccessPage.vue?vue&type=script&lang=js"
export * from "./ApprovalSuccessPage.vue?vue&type=script&lang=js"
import style0 from "./ApprovalSuccessPage.vue?vue&type=style&index=0&id=0239e2eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0239e2eb",
  null
  
)

export default component.exports